import Util from '../../analytics/util';
import Log from '../../common/log';
import { SessionsTag } from '../../common/Constants';
/**
 * Tracks metrics changes and returns only changed values
 */
export default class MetricsDiffer {
    constructor() {
        this.previousMetrics = null;
    }
    /**
     * Get changed metrics by comparing current with previous
     * @param currentMetrics - Current metrics object
     * @returns Only the metrics that have changed since last call
     */
    getChangedMetrics(currentMetrics) {
        const filtered = Util.filterChangedMetrics(currentMetrics, this.previousMetrics);
        // Update previous metrics with deep copy
        try {
            this.previousMetrics = JSON.parse(JSON.stringify(currentMetrics));
        }
        catch (e) {
            Log.warn(SessionsTag, 'Failed to deep copy session metrics for previous state. Storing shallow copy.', e);
            this.previousMetrics = Object.assign({}, currentMetrics);
        }
        return filtered;
    }
    /**
     * Reset the differ (clear previous metrics)
     */
    reset() {
        this.previousMetrics = null;
    }
    /**
     * Get the previous metrics snapshot (for testing/debugging)
     */
    getPreviousMetrics() {
        return this.previousMetrics;
    }
}
